import React from "react";
import { Flex, Box, Text, useColorModeValue } from "@chakra-ui/react";
import { NavLink, useLocation } from "react-router-dom";
import {
  HomeIcon,
  GatewayIcon,
  ProductIcon,
  SaleIcon,
  PersonIcon,
} from "../Icons/Icons";

const MOBILE_ITEMS = [
  { key: "dashboard", path: "/dashboard", icon: HomeIcon, label: "داشبورد" },
  { key: "gateways", path: "/gateways", icon: GatewayIcon, label: "درگاه‌ها" },
  { key: "products", path: "/products", icon: ProductIcon, label: "محصولات" },
  { key: "orders", path: "/orders", icon: SaleIcon, label: "سفارش‌ها" },
  { key: "profile", path: "/profile", icon: PersonIcon, label: "پروفایل" },
];

export default function MobileBottomNav() {
  const location = useLocation();
  
  // 🎨 متغیرهای رنگی تمِ مدرن (Glassmorphism)
  // بک‌گراند با شفافیت برای اعمال افکت شیشه‌ای
  const bg = useColorModeValue("rgba(255, 255, 255, 0.85)", "rgba(15, 23, 42, 0.85)");
  const border = useColorModeValue("rgba(226, 232, 240, 0.6)", "rgba(255, 255, 255, 0.08)");
  
  const activeColor = useColorModeValue("blue.600", "cyan.300");
  const inactiveColor = useColorModeValue("gray.500", "gray.400");
  const indicatorGradient = "linear(to-r, blue.400, cyan.400)";

  return (
    <Box
      position="fixed"
      bottom="0"
      left="0"
      right="0"
      zIndex="1200"
      display={{ base: "block", lg: "none" }}
      // 📱 ایجاد حاشیه امن برای آیفون‌ها و گوشی‌های بدون دکمه هوم
      pb="env(safe-area-inset-bottom)"
      bg={bg}
      backdropFilter="blur(16px)"
      WebkitBackdropFilter="blur(16px)" // پشتیبانی سافاری
      borderTopWidth="1px"
      borderTopColor={border}
      boxShadow="0 -10px 30px rgba(0, 0, 0, 0.05)"
    >
      <Flex
        px={2}
        pt={2}
        pb={3}
        justify="space-around"
        align="center"
      >
        {MOBILE_ITEMS.map(({ key, path, icon: Icon, label }) => {
          const isActive = location.pathname.startsWith(path);
          
          return (
            <NavLink key={key} to={path} style={{ flex: 1, textAlign: "center", position: "relative" }}>
              <Flex 
                direction="column" 
                align="center" 
                justify="center" 
                gap={1}
                position="relative"
                transition="all 0.3s cubic-bezier(.25,.8,.25,1)"
                transform={isActive ? "translateY(-2px)" : "translateY(0)"}
              >
                {/* 🔵 نشانگر فعال بودن (خط رنگی و گردِ بالای آیکون) */}
                <Box
                  position="absolute"
                  top="-10px" // چسبیده به بالای منو
                  w={isActive ? "28px" : "0"}
                  h="3px"
                  bgGradient={indicatorGradient}
                  borderRadius="full"
                  transition="all 0.3s ease"
                  opacity={isActive ? 1 : 0}
                />

                {/* ✨ افکت نوری ملایم پشت آیکون فعال (Glow) */}
                {isActive && (
                   <Box 
                     position="absolute"
                     top="2px"
                     w="30px" h="30px"
                     bg="blue.400"
                     filter="blur(14px)"
                     opacity={0.3}
                     borderRadius="full"
                     zIndex={-1}
                   />
                )}

                {/* 🎨 آیکون */}
                <Box
                  as={Icon}
                  boxSize={isActive ? "24px" : "22px"}
                  color={isActive ? activeColor : inactiveColor}
                  transition="all 0.3s ease"
                  mb="1px"
                />
                
                {/* 📝 متن */}
                <Text
                  fontSize="10px"
                  fontWeight={isActive ? "bold" : "medium"}
                  color={isActive ? activeColor : inactiveColor}
                  transition="all 0.3s ease"
                >
                  {label}
                </Text>
              </Flex>
            </NavLink>
          );
        })}
      </Flex>
    </Box>
  );
}